import * as models from './userModels';

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

interface SetToken { type: 'SET_TOKEN'; data: string; }
interface SetUserName { type: 'SET_USER_NAME'; data: string; }
interface SetFirstName { type: 'SET_FIRST_NAME'; firstName: string; }
interface SetLastName { type: 'SET_LAST_NAME'; lastName: string; }
interface SetContactEmail { type: 'SET_CONTACT_EMAIL'; contactEmailAddress: string; }
interface SetCrmUserId { type: 'SET_CRM_USER_ID'; crmUserId: string; }
interface SetError { type: 'SET_ERROR'; error: boolean; }
interface SetErrorMessage { type: 'SET_ERROR_MESSAGE'; errorMessage: string; }
interface SetPermissions { type: 'SET_PERMISSIONS'; data: models.Permissions; }
interface SetCustomerData { type: 'SET_CUSTOMERDATA'; customerData: models.CustomerData; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction =
    SetToken
    | SetUserName
    | SetPermissions
    | SetFirstName
    | SetLastName
    | SetContactEmail
    | SetCrmUserId
    | SetError
    | SetErrorMessage
    | SetCustomerData
    ;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const userActionCreators = {
    setToken: (token: string) => <SetToken> { type: 'SET_TOKEN', data: token },
    setUserName: (name: string) => <SetUserName> { type: 'SET_USER_NAME', data: name },
    setFirstName: (firstName: string) => <SetFirstName> { type: 'SET_FIRST_NAME', firstName: firstName },
    setLastName: (lastName: string) => <SetLastName> { type: 'SET_LAST_NAME', lastName: lastName },
    setContactEmail: (contactEmailAddress: string) => <SetContactEmail> {
        type: 'SET_CONTACT_EMAIL',
        contactEmailAddress: contactEmailAddress
    },
    setCrmUserId: (crmUserId: string) => <SetCrmUserId> {
        type: 'SET_CRM_USER_ID',
        crmUserId: crmUserId
    },
    setError: (error: boolean) => <SetError> { type: 'SET_ERROR', error: error },
    setErrorMessage: (errorMessage: string) => <SetErrorMessage> { 
        type: 'SET_ERROR_MESSAGE', 
        errorMessage: errorMessage 
    },
    setPermissions: (perm: models.Permissions) => <SetPermissions> { type: 'SET_PERMISSIONS', data: perm },    
    setCustomerData: (customerData: models.CustomerData) => <SetCustomerData> { 
        type: 'SET_CUSTOMERDATA', 
        customerData: customerData 
    },

};


// WEBPACK FOOTER //
// ./src/data/user/userActions.ts